import React from 'react';
import { connect } from 'react-redux';
import { campaignsClient } from 'apollo';
import { useQuery } from '@apollo/client';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';
import * as selectors from 'containers/Campaigns/selectors';
import * as actions from 'containers/Campaigns/actions';
import {
  GetCampaignQuery as result,
  GetCampaignQueryVariables as vars,
  GetCampaignDocument as query
} from 'generated/campaigns-graphql';
import './styles.scss';

import LoadingSpinner from 'components/LoadingSpinner';
import ViewCampaignDetails from './Details';
import { clientIdSelector } from 'store/global/selectors';
import { campaignsDataType } from 'utils/types';

interface Props {
  campaignId?: string;
  clientId: string;
  show: boolean;
  onCampaignSet(campaign: any): void;
  onClose(): void;
}

const ViewCampaignModal: React.FC<Props> = ({
  campaignId,
  clientId,
  show,
  onCampaignSet,
  onClose
}) => {
  const { data, error, loading } = useQuery<result, vars>(query, {
    client: campaignsClient as any,
    variables: { id: campaignId },
    skip: !campaignId,
    fetchPolicy: 'cache-and-network',
    onCompleted: ({ retrieve }) => {
      onCampaignSet(retrieve);
    }
  });

  const renderBody = () => {
    if (campaignId !== null) {
      let details: campaignsDataType = data && data.retrieve;
      if (error && !loading)
        return <Alert variant="danger">{`Error retrieving campaign with id: ${campaignId}`}</Alert>;
      if (loading)
        return (
          <div className="retrieving-container">
            <LoadingSpinner message="Retrieving campaign details..." />
          </div>
        );
      return <ViewCampaignDetails clientId={clientId} data={details} />;
    } else {
      return null;
    }
  };

  return (
    <Modal centered dialogClassName="view-campaign-modal" show={show} size="lg" onHide={onClose}>
      <Modal.Header closeButton>
        <div>
          <Modal.Title as="div" bsPrefix="title">
            Campaign Details
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="content">{renderBody()}</div>
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = state => ({
  campaignId: selectors.campaignIdSelector(state),
  clientId: clientIdSelector(state),
  details: selectors.detailsSelector(state),
  show: selectors.showSelector(state)
});

const mapDispatchToProps = dispatch => ({
  onCampaignSet: (campaignData: any) => {
    dispatch(actions.setCampaign(campaignData));
  },
  onClose: () => {
    dispatch(actions.setShow(false));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewCampaignModal);
